<div fxLayout="row wrap">
    <div fxFlex.gt-sm="100" fxFlex="100">
        <mat-card>
            <mat-card-content>
                <!-- <mat-card-title>Map</mat-card-title> -->
                 <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                    <div fxLayout="row wrap">
                        <div  fxFlex.gt-sm="50" fxFlex="100" class="p-10">
                            <mat-form-field style="margin-top: 15px;">
                                <mat-select placeholder="Emp Code" formControlName="code">
                                    <mat-option>None</mat-option>
                                    <mat-option *ngFor="let empCode of codes" [value]="empCode.code">{{ empCode.code}}-{{empCode.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div  fxFlex.gt-sm="50" fxFlex="100" class="p-10">
                            <mat-form-field class="m-t-15">
                                <mat-label>Date</mat-label>
                                <input matInput [matDatepicker]="customdp" formControlName="date">
                                <mat-datepicker-toggle matSuffix [for]="customdp"></mat-datepicker-toggle>
                                <mat-datepicker #customdp></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="margin-bottom: 10px; margin-left: 10px;">
                            <button mat-raised-button color="primary" type="submit" [disabled]="!formGroup.valid">Search</button>
                        </div>
                    </div>
                </form> 
                <div class="map-wrap">
                    <div class="map" #map></div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
